module.exports = __webpack_public_path__ + "static/img/28.5d2294f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/28.png
// module id = pvWR
// module chunks = 1